import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationState } from '../../../../cvp-webgames-core/UI/Animation/animation-base';
import { AnimationPage } from '../../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../../misc/constants';
import { BaseConfig } from '../../../BaseConfig';
import PopUp1 from '../../../general/pop-up1';

import "./main-menu-window.css"
import { getGlobalTextSizeStyle, setFocus, setLast508WindowId, TextHtmlTagType } from '../../../../misc/tools';

class MainMenuWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'start-scenarios-jcdst',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/start-scenarios.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'resume-game-jcdst',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/resume-game.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'settings-jcdst',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/settings.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'reference-materials-jcdst',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/reference-materials.svg'
			}
		];
	}
}

export const mainMenuWindowCaching = new MainMenuWindowCaching();

const MainMenuWindow = (props: MainMenuWindowConfig) => {
	const root = useRef(null);
	const [focusSet, setFocusSet] = useState(false);
	if(!focusSet) {
		setTimeout(() => {
			setFocus('main-menu-window-top');
		}, 1000);
		setFocusSet(true);
	}

	useEffect(() => {
		props.animation.updateProps({
			page: root.current
		});
	}, [root])

	return (
		<div ref={root} className={"modal-disable-select center-element main-menu-window-container " + props.animation.getInitialClass()} style={{
		}}>
			<PopUp1
				title= {constants.projectTitle}
				buttons={[
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('start-scenarios-jcdst').src,
						idFor508: 'main-menu-window-top',
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Start Scenarios",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onStartScenariosClicked
					},
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('resume-game-jcdst').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Resume Game",
						hoverColor: '#bfddff',
						bgColor: undefined,
						disabled: !props.isResumeUnlocked,
						onClick: props.onResumeGameClicked
					},
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('settings-jcdst').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Settings",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onSettingsClicked
					},
					{
						imgSrc: mainMenuWindowCaching.getItemByKey('reference-materials-jcdst').src,
						alt508: '',
						width: '80%',
						height: '80px',
						buttonText: "Reference Materials",
						hoverColor: '#bfddff',
						bgColor: undefined,
						onClick: props.onReferenceMaterialsClicked
					}
				]}
				onRenderContent={() => {
					return (
						<p className='default-text center-element-horizontal white-text' style={{
							textAlign:'center',
							width: '100%',
							...getGlobalTextSizeStyle(TextHtmlTagType.p)
						}}>
							<span className='title-text2 white-text'>Main Menu</span><br />
							<br />
							Please select an option:
						</p>);
				}}></PopUp1>
		</div>
	);
};

export interface MainMenuWindowConfig extends BaseConfig {
	animation: AnimationPage;
	isResumeUnlocked: boolean;
	onStartScenariosClicked: () => void;
	onResumeGameClicked: () => void;
	onSettingsClicked: () => void;
	onReferenceMaterialsClicked: () => void;
}

export default MainMenuWindow;